import { Injectable} from '@angular/core';
import { FlowSheet, DataSrc } from '../../models/flowsheet/flowsheet.model';
import { Model } from '../../models/flowsheet/Model.model';
import { InputParameter } from '../../models/flowsheet/inputParameters.model';
import { ModelParameter } from '../../models/mlmodel/mlModel-parameters.model';
import { OutputParameter } from '../../models/flowsheet/outputParameters.model';
import { FlowsheetBuilderComponent } from '../../flowsheet-builder/flowsheet-builder.component';
import { concatMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ParameterModel } from 'src/app/models/flowsheet/parameter.model';

@Injectable({
  providedIn: 'root'
})

export class FlowSheetEventsHandler {
  public destroyed = new Subject<any>();

  constructor() {
    // constructor is empty
  }

  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.complete();
  }

  calculateInitialModels(flowSheet: FlowSheet) {
    flowSheet.initialModelUniqueIds = [];
    flowSheet.models.filter(m => m.srcModels.length == 0).forEach((model) => {
      flowSheet.initialModelUniqueIds.push(model.modelUniqueId);
    });
  }

  addModel(flowsheetBuilder: FlowsheetBuilderComponent, modelUniqueId, modelId, modelName, modelVersion){
    let model = new Model();
    model.modelUniqueId = modelUniqueId;
    model.modelId = modelId;
    model.modelName = modelName;
    model.modelVersion = modelVersion;
    this.setUpModelParameters(model, flowsheetBuilder);

    flowsheetBuilder.flowSheet.models.push(model);
  }

  setUpModelParameters(model: Model, flowsheetBuilder: FlowsheetBuilderComponent) {
    flowsheetBuilder.mlService.getModelParameters(model.modelId)
    .pipe(
      takeUntil(this.destroyed),
      concatMap(async (data: any) => {
        this.addInputParameter(model, data.inputParameters);
        this.addOutputParameter(model, data.outputParameters);
        flowsheetBuilder.isLoading = false;
      })
    ).subscribe()
  }

  addInputParameter(model: Model, inputParameters: any) {
    inputParameters.forEach((param) => {
      let inputParam = new InputParameter();
      inputParam.data = this.parseParameterData(param);
      model.inputParameters.push(inputParam);
    });
  }

  addOutputParameter(model: Model, outputParameters: any) {
    outputParameters.forEach((param) => {
      let outputParam = new OutputParameter();
      outputParam.data = this.parseParameterData(param);
      model.outputParameters.push(outputParam);
    });
  }

  parseParameterData(param: any): ModelParameter {
    let parameter = new ModelParameter();
    parameter.parameterId = param.parameterId;
    parameter.parameterName = param.parameterName;
    parameter.parameterDataType = param.parameterDataType;
    parameter.parameterUom = param.parameterUom;
    parameter.captionName = param.captionName;

    return parameter;
  }

  removeModel(flowSheet: FlowSheet, modelUniqueId) {
    let index = flowSheet.models.findIndex(m => m.modelUniqueId == modelUniqueId);
    if (index > -1) {
      // remove model from flowsheet
      flowSheet.models.splice(index, 1);
      index = flowSheet.initialModelUniqueIds.findIndex(m => m == modelUniqueId);
      flowSheet.initialModelUniqueIds.splice(index, 1);
    }
  }

  removeSrcModelParameterMappings(model: Model, srcModelUniqueId: any) {
    let mappedInputParams = model.inputParameters.filter((param) => {
      return param.mappedDataSource == DataSrc.model && param.mappedDataSourceId == srcModelUniqueId;
    });
    mappedInputParams.forEach((param) => { this.resetParameterSrcMapData(param); });
  }

    updateParameterMapping(parameterModel : ParameterModel) {

    let param = parameterModel.model.inputParameters.find(p => p.data.parameterId == parameterModel.parameterId);

    param.mappedDataSource = parameterModel.dataSource;
    param.mappedDataSourceId = parameterModel.dataSourceId;
    param.mappedFrequency = parameterModel.srcFrequency;
    param.mappedParameterId = parameterModel.srcParameterId;
    param.mappedParameterName = parameterModel.srcParameterName;
    param.mappedParameterUoM = parameterModel.srcParameterUoM;
    param.data.parameterDefaultValue = parameterModel.defaultValue;
  }

  resetParameterSrcMapData(param: InputParameter) {
    param.mappedDataSource = DataSrc.user;
    param.mappedDataSourceId = '';
    param.mappedParameterId = 0;
    param.mappedParameterName = '';
    param.mappedFrequency = 0;
    param.mappedParameterUoM = '';
  }

  returnParameterToOriginalPosition(paramList, param) {
    let args = paramList
    .filter(p => p.data.parameterId < param.data.parameterId)
    .map(function (p) { return p.data.parameterId; });
    let prevIndex = Math.max(...args);
    prevIndex = prevIndex < 0 ? 0 : prevIndex;
    paramList.splice(prevIndex, 0, param);
  }
}

